<template>
  <div class="modal fade" id="Import" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-10 my-auto">
            <h5 class="modal-title" id="EndBankAccountLabel">Import Service Bundle</h5>
          </div>
          <div class="col-2 my-auto">
            <span>
              <a class="close">
                <i
                  class="far fa-times-circle fa-2x"
                  data-dismiss="modal"
                  id="closeImportServiceBundle"
                  aria-label="Close"
                ></i>
              </a>
            </span>
          </div>
        </div>
        <div class="container-fluid">
          <form>
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <b-form-file
                      class="text-center"
                      v-model="selected"
                      :state="Boolean(isValid && !errorMessages)"
                      accept=".json"
                      ref="file-input"
                      @input="readFile"
                    />
                    <div class="text-center mt-4 font-weight-bold" v-if="selected && !isValid">
                      <p class="font-weight-bold" style="color:red">The selected file does not contain valid json</p>
                    </div>
                    <div v-if="errorMessages" class="my-4">
                      <div v-for="(messages, error) in errorMessages" :key="error">
                        <div class="row" v-for="(message, index) in messages" :key="index">
                          <p class="col-sm col-md-4 font-weight-bold">{{formatErrorTitle(error)}}:</p>
                          <p class="col" style="color: red">{{"\t" + message}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 mt-4 text-center">
                    <button
                      type="submit"
                      class="btn btn-hc w-40 mr-2 mb-3"
                      :disabled="submitStatus === 'PENDING' || (!serviceBundle || errorMessages)"
                      @click.prevent="submit"
                    >Import</button>
                    <button
                      type="submit"
                      class="btn btn-hc w-40 ml-2 mb-3"
                      data-dismiss="modal"
                      aria-label="Close"
                    >Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitStatus: null,
      selected: null,
      serviceBundle: null,
      errorMessages: null,
      isValid: false,
    };
  },
  computed: {
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    },
  },
  methods: {
    formatErrorTitle(error) {
      return this.wordSplit(error.match(/\b[a-zA-Z]+?$/));
    },
    processFile(event) {
      this.selected = event.target.files[0];
    },
    readFile() {
      this.errorMessages = null;
      const reader = new FileReader();
      reader.readAsText(this.selected);
      reader.onload = (e) => {
        try {
          this.serviceBundle = JSON.parse(e.target.result);
          this.isValid = true;
        } catch {
          this.isValid = false;
        }
      };
    },
    submit() {
      if (this.selected == null || this.serviceBundle == null) {
        this.$snotify.warning(
          `No file selected - please select a service bundle to import.`
        );
        return false;
      }
      this.submitStatus = "PENDING";
      this.$snotify.async(
        "Adding Service Bundle",
        () =>
          new Promise((resolve, reject) => {
            this.$http
              .post(
                "https://" +
                  this.$config.honeycomb.contractbot.domain +
                  "/api/v1/ServiceBundles/complete",
                this.serviceBundle,
                {
                  withCredentials: true,
                }
              )
              .then(() => {
                this.submitStatus = "OK";
                this.serviceBundle = null;
                this.selected = null;
                this.validated = false;
                this.$refs["file-input"].reset();
                document.getElementById("closeImportServiceBundle").click();
                resolve({
                  body: "Success! Service bundle imported.",
                  config: {
                    closeOnClick: true,
                    timeout: 2000,
                  },
                });
              })
              .catch((error) => {
                this.submitStatus = "ERROR";
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of this 2xx
                  if (
                    error.response.data.hasOwnProperty("MoreInformation") &&
                    error.response.data.MoreInformation.length > 0
                  ) {
                    error.response.data.MoreInformation.forEach((e) => {
                      this.$snotify.error(`${e.Error}`, {
                        timeout: 0,
                        closeOnClick: true,
                      });
                    });
                    // snotify async reject object
                    reject({
                      title: "Error",
                      config: {
                        closeOnClick: true,
                        timeout: 1,
                      },
                    });
                  } else {
                    // snotify async reject object
                    this.errorMessages = error.response.data;
                    reject({
                      body: `Json failed to validate`,
                      config: {
                        closeOnClick: true,
                      },
                    });
                  }
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  // snotify async reject object
                  reject({
                    title: "Error",
                    body: "No response received.",
                    config: {
                      closeOnClick: true,
                    },
                  });
                } else {
                  // Something happened in setting up the request that triggered an Error
                  // snotify async reject object
                  reject({
                    title: "Error",
                    body: `${error.message}`,
                    config: {
                      closeOnClick: true,
                    },
                  });
                }
              });
          })
      );
    },
  },
};
</script>
